var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAerospace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.29,117.15v12.14m0-35.11v12.14m0-35.55V82.91M86.54,51c0-12.29,9.4-22.25,21-22.25s20.7,10.28,20.7,22.57l-.09,10V172.56c0,4.15,0,18.05-13.08,18.05H100.4c-10.7,0-13.87-13.9-13.87-18.05V51Zm11.86,8.9a8.75,8.75,0,1,1,17.48,0m13,13.16s14.26,4.19,14.26,19.73v81.48m-13.87-57.12,36.07,57.12H129.23M86.13,73S71.87,77.21,71.87,92.75v81.48m13.87-57.12L49.67,174.23H85.74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerospace);
export default __webpack_public_path__ + "static/media/AEROSPACE.d2148e0305767e80117e1804f80fb99e.svg";
export { ForwardRef as ReactComponent };